module.exports = __webpack_public_path__ + "media/images/elionline/icons/autoassegnazione_a_tempo-d71531ebb539d091a832f8623c6e5b83.svg";